import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { generateUUID, isTabView } from './utils';
import { CONFIG } from './config';
import { INIT_ACTION_TYPE, MYGOORU_AI_CONTEXT_TYPE, NEW_USER, USERCATEGORY } from './constants/helper-constant';
import { NavigationEnd, Router, Event as RouterEvent } from '@angular/router';
import { filter } from 'rxjs';
import { AuthServiceHelper } from './providers/services/auth.service';
import { UserService } from '@gooru/my-gooru-ts';
import { SessionService } from '@gooru/navigator-core-widget-ui';
import { UserContextService } from './providers/services/user-context.service';
import { OtpService } from './providers/services/otp.service';
import { AuthService } from '@gooru/navigator-auth-widget-ui';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  @ViewChild('aiContainer') public aiContainer!: ElementRef;
  public mygContext: any;
  public isTabView!: boolean;

  constructor(private router: Router, private authService: AuthServiceHelper, private userService: UserService, private otpService: OtpService,
      private sessionService: SessionService,     private userContextService: UserContextService, private authServiceGen: AuthService){
    this.router.events
      .pipe(
        filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        if (!event.url.startsWith('/explore')) {
          localStorage.removeItem('user_data_demo_explore');
        }
      });
  }

  public async ngOnInit() {
    this.isTabView = isTabView();
    const userAccessToken = this.getCookie('user_access_token');
    if(userAccessToken) {
      this.authService.isAutoLoginProcessing = true;
      (window as any).IS_MYGOORU_AI = true;
      (window as any).MYGOORU_SETTINGS = { "enableGeolocation": true, isFullScreen: true };
      await this.authService.autoLoginWithCookie(userAccessToken);
      this.authService.isAutoLoginProcessing = false;
    } else {
      this.initializeContext();
    }
  }

  getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  private async initializeContext() {
    // set is My Gooru AI window setting
    (window as any).IS_MYGOORU_AI = true;
    (window as any).MYGOORU_SETTINGS = { "enableGeolocation": true, isFullScreen: true };
    const { version, clientId, clientKey, appId } = CONFIG;
    const userId = generateUUID();
    // create My Gooru AI initialize context
    this.mygContext = {
      version, clientId, clientKey, appId, context: {
        type: MYGOORU_AI_CONTEXT_TYPE,
        action: INIT_ACTION_TYPE,
        user: { id: userId }
      }
    };
  }

  private async initializeAutoLoginContext(accessToken :any) {
    // set is My Gooru AI window setting
    const { version, clientId, clientKey, appId, defaultUserRole } = CONFIG;

    const userDetails = await this.userService?.getUserDetailsByToken(
      accessToken,
      appId
    );
    
    if (!userDetails || typeof userDetails === 'string') {
      console.error('Invalid user details');
      return;
    }

    (userDetails as any).appId = (userDetails as any).appId || appId; 
    this.sessionService.setSession(userDetails);

    const user = {
          "role": defaultUserRole,
          "firstname": "Guest",
          "access_code": null,
          "id": (userDetails as any).username || '',
          "email": userDetails.email || '',
          "username": (userDetails as any).username || '',
          "firstName": (userDetails as any).username || ''
        };
        this.mygContext = {
          "version": version,
          "clientId": clientId,
          "clientKey": clientKey,
          "appId": appId,
          "context": {
            "type": MYGOORU_AI_CONTEXT_TYPE,
            "action": INIT_ACTION_TYPE,
            "user": user
          }
        };

        // localStorage.setItem("user_data_demo_explore", JSON.stringify(userData));
        this.otpService.loggedIn();
        const isPhone = /^\d{10,15}$/.test((userDetails as any).username || '');
        this.userContextService.setContact({
          contact: (userDetails as any).username || '',
          contactType: isPhone ? 'phone' : 'email',
        });
  }

  public widgetResizer() {
    if (!this.isTabView) {
      // timeout used to wait for element initialize
      setTimeout(() => {
        const element = document.querySelector('#myg-widget-container .myg-widget-panel');
        if (element) {
          const resizeObserver: any = new ResizeObserver(entries => {
            for (let entry of entries) {
              //50 is added for space between marketing and learnbot
              const width = entry?.contentRect?.width + 50;
              if (this.aiContainer && this.aiContainer.nativeElement) {
                this.aiContainer.nativeElement.style.gridTemplateColumns = `1fr ${width}px`
              }
            }
          });
          resizeObserver.observe(element);
        }
      }, 1000);
    }
  }
}
